import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { MenuItem } from '@/Support/Menus/Interfaces/MenuItem'

export const userMenu = computed(
  () => usePage().props.userMenu
) as unknown as Array<MenuItem>
